import styled from "styled-components";
import ButtonUi from "../../../../../components/Button";
import {
  rainbowBackgroundGradient,
  rainbowTextGradient,
} from "../../../../../components/StyledComponents";
import LinkUi from "../../../../../components/Link";

export const Button = styled(ButtonUi)`
  ${rainbowBackgroundGradient}
  border: 0px;
  height: 45px;
`;

export const Link = styled(LinkUi)`
  ${rainbowBackgroundGradient}
  border: 0px;
  height: 45px;
`;